import React from 'react';

import Screen, {backButton, useReportButton} from 'editor/screens/Screen';
import {COPY} from 'text/errors';

/**
 * A project whose conversion to the new editor failed (DQ5). The conversion is not retried, so there is no Retry. `reupload` is the no_detection
 * finding: the file matches no supported release, and the way forward is to upload it again. `code` is what the ticket says the open failed with.
 */
export default function ConversionFailed({projectId, code, reupload = false}) {
    const report = useReportButton(projectId, code);
    const copy = COPY.screens.conversionFailed;

    return <Screen title={copy.title} body={reupload ? [copy.body, copy.reupload] : [copy.body]} buttons={[report, backButton]}/>;
}
